import script from "./PrepopWelcomeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PrepopWelcomeModal.vue?vue&type=script&setup=true&lang=js"

import "./PrepopWelcomeModal.vue?vue&type=style&index=0&id=59258608&scoped=true&lang=css"

import exportComponent from "/Users/alberto/sites/newform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59258608"]])

export default __exports__